/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Final_LeadInputs */

const en_dr_final_lead = /** @type {(inputs: Dr_Final_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six steps, one link, zero accounts for guests — and a PRD that can point back to exactly why each feature exists.`)
};

const id_dr_final_lead = /** @type {(inputs: Dr_Final_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enam langkah, satu tautan, nol akun untuk peserta tamu — dan PRD yang bisa menunjukkan persis kenapa tiap fitur ada.`)
};

/**
* | output |
* | --- |
* | "Six steps, one link, zero accounts for guests — and a PRD that can point back to exactly why each feature exists." |
*
* @param {Dr_Final_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_final_lead = /** @type {((inputs?: Dr_Final_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Final_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_final_lead(inputs)
	return en_dr_final_lead(inputs)
});